import { useEffect, useState } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, HashRouter, Switch, Route } from 'react-router-dom';

import { getRouterType, getTenantId } from 'common/helpers/apiHelper';
import {
  timeFormatNoSettings,
  getClientTimezone
} from 'common/helpers/dateHelper';
import {
  isShutDown,
  getShutdownWindow
} from 'common/helpers/sharedFeatureFlags';
import { getForWeb } from 'redux/settings/actions';
import { asyncPingV1Api } from 'utils/helper';

import InvalidTenant from './InvalidTenant';
import Cart from './cart/Cart';
import Checkout from './checkout/App';
import Club from './club/App';
import Product from './products/Detail';
import Collection from './products/List';
import Profile from './profile/App';
import Reservation from './reservations/App';

const Routes = () => {
  const [isInvalidTenant, setIsInvalidTenant] = useState(false);
  const dispatch = useDispatch();
  const setting = useSelector((state) => state.setting.data);

  useEffect(() => {
    asyncPingV1Api();
  }, [dispatch]);

  useEffect(() => {
    const onError = () => {
      setIsInvalidTenant(true);
    };
    dispatch(getForWeb(onError));
  }, [dispatch]);

  if (isInvalidTenant) {
    return <InvalidTenant />;
  }

  const router = getRouterType();
  let Router = BrowserRouter;
  if (router === 'hash') {
    Router = HashRouter;
  }

  if (isShutDown(getTenantId())) {
    const { endTime } = getShutdownWindow();
    const timeZone = getClientTimezone();
    return (
      <p style={{ textAlign: 'center', margin: '0 auto' }}>
        Our ecommerce provider is undergoing system maintenance until
        approximately{' '}
        {`${timeFormatNoSettings(endTime, timeZone)} (${timeZone} time)`}.{' '}
        <br /> Please check back soon or contact us.
      </p>
    );
  }

  if (!setting) {
    return <></>;
  }

  return (
    <>
      <GoogleReCaptchaProvider
        reCaptchaKey="6LfaKNkgAAAAAK8eObCn0Gu5gRtJjmwNNhUhAqKV"
        language="en"
        useRecaptchaNet="false"
        useEnterprise="true"
        scriptProps={{
          async: false, // optional, default to false,
          defer: false, // optional, default to false
          appendTo: 'head', // optional, default to "head", can be "head" or "body",
          nonce: undefined // optional, default undefined
        }}
      >
        <Router>
          {/* <ErrorBoundary> */}
          {/* <React.StrictMode> */}
          <Switch>
            <Route exact={false} path="/cart" component={Cart} />
            <Route exact={false} path="/checkout" component={Checkout} />

            <Route exact={false} path="/club" component={Club} />
            <Route
              exact={false}
              path="/collection/*/:slug"
              component={Collection}
            />
            <Route
              exact={false}
              path="/collection/:slug"
              component={Collection}
            />
            <Route exact={false} path="/product/:slug" component={Product} />
            <Route exact={false} path="/profile" component={Profile} />
            <Route exact={false} path="/reservation" component={Reservation} />
          </Switch>
          {/* </React.StrictMode> */}
        </Router>
      </GoogleReCaptchaProvider>
    </>
  );
};

export default Routes;
